import type { FunctionComponent } from 'react';

import IconBulb from 'assets/images/icon-bulb-48px.svg';

import Item from './Item';

import './style.scss';

const GreatContentTips: FunctionComponent = () => (
  <div styleName="container">
    <div styleName="header">
      <div styleName="bulbIcon">
        <IconBulb />
      </div>
      Creating Great Content Tips
    </div>
    <Item title="Keep it real">
      Authenticity over production value
    </Item>
    <Item title="Offer modifications">
      Make it accessible to all levels
    </Item>
    <Item title="State the intention">
      What are we addressing?
    </Item>
    <Item title="Mix modalities">
      Combine breath, movement, stillness
    </Item>
    <Item title='Think "work-in"'>
      This isn&apos;t about performance, it is about creating a space and
      environment where the Thrivers seek out healing through modalities
      assembled by our AI assistant.
    </Item>
  </div>
);

export default GreatContentTips;
